import { createFileRoute } from "@tanstack/react-router";
import { ErrorState, QueryBoundary } from "@/components/shell/page";
import { useProject } from "@/components/shell/workspace-context";
import { TriageHeader, TriageView } from "@/components/triage/triage-view";

type TriageSearch = {
  /** The other side of the queue: tickets put away until a date. */
  view?: "snoozed";
  /** A ticket number to start on. */
  ticket?: number;
};

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/triage")({
  validateSearch: (search): TriageSearch => {
    const ticket = Number(search.ticket);
    return {
      view: search.view === "snoozed" ? "snoozed" : undefined,
      ticket: Number.isSafeInteger(ticket) && ticket > 0 ? ticket : undefined,
    };
  },
  component: TriagePage,
});

function TriagePage() {
  const project = useProject();
  const { view, ticket } = Route.useSearch();
  const snoozed = view === "snoozed";
  // Each project, and each side of its queue, is its own list: the keyboard
  // starts again at the top.
  const key = `${project._id}:${snoozed ? "snoozed" : "queue"}`;
  return (
    <QueryBoundary
      resetKey={key}
      fallback={(retry) => (
        <>
          <TriageHeader />
          <ErrorState onRetry={retry} />
        </>
      )}
    >
      <TriageView key={key} snoozed={snoozed} focusNumber={ticket} />
    </QueryBoundary>
  );
}
